<template>
    <div class="admin-models">
        <h2>Gestion des Models</h2>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "AdminProductModel",
        created() {
        },
        data() {
            return {}
        },
        computed: {},
        methods: {
            ...mapActions('product', [
                'getColors',
            ]),
        }
    }
</script>

<style scoped lang="scss">

</style>
